import $ from 'jquery';

const ToggleFilter = (el) => {
    el.addEventListener('click', () => {

        $(el).toggleClass('js-filter-toggle-active');
        $(el).next('.filter__select-list').toggle();

        if($(el).hasClass('js-filter-toggle-active')) {
            $(el).attr('aria-expanded', 'true');
        } else {
            $(el).attr('aria-expanded', 'false');

        }
    });
};

export default ToggleFilter;
